import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-81b4adf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scenario-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "header" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "noise" })
], -1))
const _hoisted_4 = { class: "body grid-parent" }
const _hoisted_5 = { class: "points-counter" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, " PTS ", -1))
const _hoisted_7 = { class: "left-clock" }
const _hoisted_8 = { class: "right-clock" }
const _hoisted_9 = { class: "exit" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Exit ")
const _hoisted_11 = { class: "leftbar" }
const _hoisted_12 = {
  key: 0,
  class: "debug"
}
const _hoisted_13 = { class: "stats" }
const _hoisted_14 = { class: "stats" }
const _hoisted_15 = { class: "stats" }
const _hoisted_16 = { class: "stats" }
const _hoisted_17 = { class: "stats" }
const _hoisted_18 = { class: "time-point-stats" }
const _hoisted_19 = { class: "time-counter" }
const _hoisted_20 = { class: "time-element" }
const _hoisted_21 = { class: "value" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "min", -1))
const _hoisted_23 = { class: "time-element" }
const _hoisted_24 = { class: "value" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "sec", -1))
const _hoisted_26 = { class: "text-4xl font-bold text-warning-500" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-sm" }, "Max PTS available", -1))
const _hoisted_28 = { class: "m-2" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-sm" }, "Objective", -1))
const _hoisted_30 = { class: "checklist-header" }
const _hoisted_31 = { class: "checklist-title" }
const _hoisted_32 = { class: "pretitle" }
const _hoisted_33 = { class: "control" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "rightbar" }
const _hoisted_36 = {
  key: 0,
  class: "inventory"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "gap-4 metrics" }
const _hoisted_39 = { class: "pretitle text-military-green-500" }
const _hoisted_40 = { class: "pretitle text-military-green-500" }
const _hoisted_41 = {
  key: 0,
  class: "achievements"
}
const _hoisted_42 = { class: "flex items-end" }
const _hoisted_43 = { class: "font-bold" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "uppercase" }, "new achievement unlocked", -1))
const _hoisted_45 = { class: "underline" }
const _hoisted_46 = { class: "flex flex-col gap-4 font-bold text-military-green-500" }
const _hoisted_47 = { class: "flex flex-row gap-2" }
const _hoisted_48 = { class: "flex flex-row gap-2" }

import { useGlobalStore } from '../store/globalStore';
import {
  onMounted,
  ref,
  onUnmounted,
  computed,
  markRaw,
  watch,
  toRef
} from 'vue';
import ClockTimerComponent from '@/components/studentPage/ClockTimerComponent.vue';
import { RouteNames } from '../router/Routes';
import ButtonComponent from '../components/ButtonComponent.vue';
import { RouterView, useRouter } from 'vue-router';
import ExitModalComponent from '../components/ExitModalComponent.vue';
import HeaderbarComponent from '../components/system/components/inventory/HeaderBarComponent.vue';
import ScenarioCompleteModalComponent from '../components/ScenarioCompleteModalComponent.vue';
import ControlComponent from '../components/system/components/ControlComponent.vue';
import { InventoryItemOption, useLoadout } from '../ecs/loadout/main';
import Icon from '../components/icon/Icon';
import LoadoutInventoryItemComponent from '../components/system/components/inventory/LoadoutInventoryItemComponent.vue';
import { Scenario } from '../ecs/types';
import MarqueeCardWidget from '@/components/system/components/MarqueeCardWidget.vue';
import { secondsToMinutes } from '@/utils/utils';
import RecursiveChecklistComponent from '../components/system/components/checklist/RecursiveChecklistComponent.vue';
import SquareDotTimerWidget from '@/components/SquareDotTimerWidget.vue';
import {
  ChecklistItemComposable,
  ChecklistViewModel
} from '../ecs/completable/Completable';
import { Achievement } from '../models/Achievement';
import IconComponent from '@/components/icon/IconComponent.vue';
import { useScenarioStore } from '../store/scenarioStore';
import { OnCollectibleCategorizedPointCreated } from '../ecs/module/Module';


export default /*#__PURE__*/_defineComponent({
  __name: 'ScenarioPage',
  props: {
    scenario: null
  },
  setup(__props: any) {

const props = __props as {
  scenario: Scenario;
}



const router = useRouter();
const scenarioStore = useScenarioStore();
const globalStore = useGlobalStore();
const modalActive = ref(false);
const scenarioCompleteModalActive = ref(false);

const debug = false;
const activeModule = toRef(props.scenario.scenarioState, 'activeModule');
const newAchievements = ref([] as Achievement[]);
const scenario = toRef(props, 'scenario');
const scenarioState = toRef(scenario.value, 'scenarioState');
const totalChecklistCount = toRef(scenarioState.value, 'totalChecklistCount');
// eslint-disable-next-line vue/no-setup-props-destructure
const scenarioPointsPossible = props.scenario.scenarioState.totalPointsPossible;
const elapsedTime = toRef(scenario.value.scenarioState, 'elapsedTime');

const baseSirenAlertState = computed(
  () => activeModule.value.baseSiren.active.value.active === true
);

const giantVoiceAlertState = computed(
  () => activeModule.value.giantVoice.active.value === true
);

function findActiveChecklistViewModel(): ChecklistViewModel | null {
  let result: ChecklistViewModel | null = null;

  function searchInComposable(
    checklistItemComposable: ChecklistItemComposable
  ) {
    if (checklistItemComposable.checklist.value.active) {
      result = checklistItemComposable.checklist.value;
    } else {
      checklistItemComposable.children.forEach(
        (checklistItemComposableChild) => {
          searchInComposable(checklistItemComposableChild);
        }
      );
    }
  }

  activeModule.value.checklists
    .filter((checklist) => checklist.selected.value)
    .forEach((selectableChecklist) => {
      selectableChecklist.composable.children.forEach(
        (selectableChecklistComposableChild) => {
          searchInComposable(selectableChecklistComposableChild);
        }
      );
    });
  return result;
}

const activeChecklistTimer = computed(() => {
  const activeChecklistViewModel = findActiveChecklistViewModel();
  if (activeChecklistViewModel && activeChecklistViewModel.timer) {
    return activeChecklistViewModel.timer;
  }

  return {
    limit: 0,
    remaining: 0
  };
});

const currentObjective = computed(() => {
  return findActiveChecklistViewModel();
});

const incomingCallAlert = computed(() => {
  return !!scenarioStore.getIncomingPhoneCall;
});

const incomingRadioTransmissionAlert = computed(() => {
  return !!scenarioStore.getIncomingRadioTransmission;
});

const handleMarqueeAcknowledged = () => {
  props.scenario.scenarioState.activeModule.value.acknowledge();
};

watch(activeModule, () => {
  router.push({
    replace: true,
    name: RouteNames.SCENARIO
  });
});

scenarioState.value.onComplete(async () => {
  await scenarioStore.generateHistory(scenarioState.value.history.value);
  await awardLiftOffAchievement();
});

const loadout = useLoadout([
  {
    name: 'QRCS',
    icon: Icon.CHECKLIST,
    routeName: RouteNames.INVENTORY_CHECKLIST,
    inventoryComponent: markRaw(LoadoutInventoryItemComponent),
    onSelect: () => {
      return;
    }
  },
  {
    name: 'Phone Lines',
    icon: Icon.PHONE,
    routeName: RouteNames.INVENTORY_PHONE,
    inventoryComponent: markRaw(LoadoutInventoryItemComponent),
    onSelect: () => {
      return;
    },
    alert: incomingCallAlert
  },
  {
    name: 'Base Siren',
    icon: Icon.BASE_SIREN,
    routeName: RouteNames.INVENTORY_BASE_SIREN,
    inventoryComponent: markRaw(LoadoutInventoryItemComponent),
    onSelect: () => {
      return;
    },
    alert: baseSirenAlertState
  },
  {
    name: 'Giant Voice',
    icon: Icon.GIANT_VOICE,
    routeName: RouteNames.INVENTORY_GIANT_VOICE,
    inventoryComponent: markRaw(LoadoutInventoryItemComponent),
    onSelect: () => {
      const giantVoice = scenarioStore.getGiantVoice;
      if (giantVoice) {
        giantVoice.call();
      }
    },
    alert: giantVoiceAlertState
  },
  {
    name: 'Radio',
    icon: Icon.RADIO,
    routeName: RouteNames.INVENTORY_RADIO,
    inventoryComponent: markRaw(LoadoutInventoryItemComponent),
    onSelect: () => {
      return;
    },
    alert: incomingRadioTransmissionAlert
  },
  {
    name: 'Cameras',
    icon: Icon.CAMERA,
    routeName: RouteNames.INVENTORY_NONE,
    inventoryComponent: markRaw(LoadoutInventoryItemComponent),
    onSelect: () => {
      return;
    },
    disabled: ref(true)
  }
]);

props.scenario.onCollectiblePointCreated(
  async (event: OnCollectibleCategorizedPointCreated) => {
    if (globalStore.currentUser?.uid) {
      globalStore.rewardPoints(
        globalStore.currentUser.uid,
        event.payload.worth,
        event.category
      );
      scenarioState.value.addPoint(event.payload.worth);
    }
    if (
      scenarioState.value.pointsEarned.value === scenarioPointsPossible &&
      globalStore.currentUser
    ) {
      await globalStore.fetchAchievements(globalStore.currentUser.uid);
      const userHasAchievement = globalStore.achievements.find(
        (achievement) => achievement.id === 'laser-precision'
      );

      if (!userHasAchievement) {
        newAchievements.value.push({
          id: 'laser-precision',
          icon: Icon.BADGE_LASER_PRECISION,
          dateAchieved: new Date(),
          label: 'Laser Precision'
        });
      }

      globalStore.addAchievement(
        globalStore.currentUser.uid,
        'laser-precision'
      );
    }
  }
);

const awardLiftOffAchievement = async () => {
  const liftOffAchievement = {
    id: 'lift-off',
    icon: Icon.BADGE_LIFT_OFF,
    dateAchieved: new Date(),
    label: 'Lift Off'
  };
  if (!globalStore.currentUser) {
    return;
  }
  await globalStore.fetchAchievements(globalStore.currentUser.uid);
  const userHasLiftOffAchievement = globalStore.achievements.find(
    (achievement) => achievement.id === 'lift-off'
  );
  if (!userHasLiftOffAchievement) {
    newAchievements.value.push(liftOffAchievement);
    globalStore.addAchievement(globalStore.currentUser.uid, 'lift-off');
  }
};

const handleReroute = (routeName: string) => {
  router.push({ name: routeName });
};

const toggleModal = () => {
  modalActive.value = !modalActive.value;
};

const toggleScenarioCompleteModal = () => {
  scenarioCompleteModalActive.value != scenarioCompleteModalActive.value;
};

const handleLoadoutItemClick = (item: InventoryItemOption) => {
  if (item.disabled.value) {
    return;
  }
  loadout.selectOption(item);
  router.push({ name: item.routeName });
};

onMounted(() => {
  globalStore.pageViewEvent(RouteNames.SCENARIO);
});

onUnmounted(() => {
  props.scenario.cleanup();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h3", null, _toDisplayString(_unref(scenarioState).pointsEarned), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(ClockTimerComponent)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(ClockTimerComponent, { useUTC: false })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(ButtonComponent, {
            onClick: toggleModal,
            "data-testid": "exit-button",
            "color-type": "tertiary",
            size: "medium"
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_11, [
          debug
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(HeaderbarComponent, { title: "DEBUG" }),
                _createElementVNode("section", _hoisted_13, " Scenario Complete: " + _toDisplayString(_unref(scenario).scenarioState.complete.value), 1),
                _createElementVNode("section", _hoisted_14, " Current Objective: " + _toDisplayString(_unref(currentObjective)?.description.description), 1),
                _createElementVNode("section", _hoisted_15, " Active Module: " + _toDisplayString(_unref(activeModule).description.value.description), 1),
                _createElementVNode("section", _hoisted_16, " Active Module Complete?: " + _toDisplayString(_unref(activeModule).completable.value.value), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode(HeaderbarComponent, { title: "STATS" }),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(elapsedTime).minutes), 1),
                  _hoisted_22
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(elapsedTime).seconds), 1),
                  _hoisted_25
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_26, _toDisplayString(_unref(scenarioState).totalPointsPossible), 1),
                _hoisted_27
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createVNode(SquareDotTimerWidget, { timer: _unref(activeChecklistTimer) }, null, 8, ["timer"]),
              _hoisted_29
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activeModule).checklists.filter(
            (checklist) =>
              checklist.selected.value && checklist.composable.children.length
          ), (checklistState, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "mb-2 checklist-body",
              key: index
            }, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("span", _hoisted_32, _toDisplayString(checklistState.composable.checklist.value.description.title ||
                'NO TITLE'), 1)
                ])
              ]),
              _createVNode(RecursiveChecklistComponent, {
                class: "mb-2",
                checklist: checklistState.composable
              }, null, 8, ["checklist"])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_33, [
          (_unref(activeModule))
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                (_openBlock(), _createBlock(MarqueeCardWidget, {
                  acknowledged: _unref(activeModule).acknowledged.value,
                  key: 
              _unref(activeModule).description.value.description +
              _unref(activeModule).description.value.title
            ,
                  class: "marquee-card",
                  title: _unref(activeModule).description.value.title,
                  description: _unref(activeModule).description.value.description,
                  onOnAcknowledge: handleMarqueeAcknowledged
                }, null, 8, ["acknowledged", "title", "description"]))
              ]))
            : _createCommentVNode("", true),
          _createVNode(ControlComponent, null, {
            body: _withCtx(() => [
              _createVNode(_unref(RouterView))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createVNode(HeaderbarComponent, { title: "INVENTORY" }),
          (_unref(activeModule).acknowledged.value)
            ? (_openBlock(), _createElementBlock("section", _hoisted_36, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(loadout).options, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    onClick: ($event: any) => (handleLoadoutItemClick(item))
                  }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(item.inventoryComponent), _normalizeProps(_guardReactiveProps({ item })), null, 16)),
                    _createElementVNode("label", null, _toDisplayString(item.name), 1)
                  ], 8, _hoisted_37))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(ExitModalComponent, {
      "modal-active": modalActive.value,
      onToggle: toggleModal,
      onReroute: _cache[0] || (_cache[0] = ($event: any) => (handleReroute(_unref(RouteNames).STUDENT)))
    }, null, 8, ["modal-active"]),
    _createVNode(ScenarioCompleteModalComponent, {
      "modal-active": _unref(scenario).scenarioState.complete.value,
      onToggle: toggleScenarioCompleteModal,
      onReroute: handleReroute
    }, {
      content: _withCtx(() => [
        _createElementVNode("section", _hoisted_38, [
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_39, " Time Spent: " + _toDisplayString(_unref(secondsToMinutes)(
                _unref(scenarioState).elapsedTime.value.secondsRaw +
                  _unref(scenarioState).elapsedTime.value.minutesRaw * 60
              )), 1),
            _createElementVNode("p", _hoisted_40, " Points Earned: " + _toDisplayString(_unref(scenarioState).pointsEarned) + "/" + _toDisplayString(_unref(scenarioState).totalPointsPossible), 1)
          ]),
          (newAchievements.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                _createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newAchievements.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "achievement"
                    }, [
                      _createElementVNode("div", _hoisted_42, [
                        _createVNode(IconComponent, {
                          icon: _unref(Icon).ACHIEVEMENT_TROPHY,
                          class: "mr-4"
                        }, null, 8, ["icon"]),
                        _createElementVNode("div", _hoisted_43, [
                          _hoisted_44,
                          _createElementVNode("p", _hoisted_45, _toDisplayString(item.label), 1)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createVNode(IconComponent, {
                icon: _unref(Icon).GREEN_CHECKBOX,
                class: "rounded"
              }, null, 8, ["icon"]),
              _createElementVNode("p", null, " CORRECT ACTION, IN TIME: " + _toDisplayString(_unref(totalChecklistCount).total - _unref(totalChecklistCount).compromisedCount) + " TASKS ", 1)
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createVNode(IconComponent, {
                icon: _unref(Icon).RUST_CHECKBOX,
                class: "rounded"
              }, null, 8, ["icon"]),
              _createElementVNode("p", null, " INCORRECT ACTION: " + _toDisplayString(_unref(totalChecklistCount).compromisedCount) + " TASK ", 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modal-active"])
  ], 64))
}
}

})